import React, { useEffect } from 'react';

export default function Lightbox({
  isOpen,
  onClose,
  title,
  maxWidth = '520px',
  borderRadius = '0px',
  overlayClassName = '',
  contentClassName = '',
  headerStyle = {},
  titleStyle = {},
  children
}) {
  // Lock body scrolling when modal is active
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className={`modal-overlay ${overlayClassName}`} onClick={onClose}>
      <div
        className={`modal-content ${contentClassName}`}
        style={{ maxWidth, borderRadius }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header" style={headerStyle}>
          <h3 style={titleStyle}>{title}</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        {children}
      </div>
    </div>
  );
}
